import { useMemo } from 'react'
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import React from 'react';
import CheckoutForm from '../../components/CheckoutForm';
import './Store.css';

export const StoreDetails = props => {
    const stripePromise = useMemo(
        () => {
            if (process.env.NODE_ENV === 'development' || document.location.host.indexOf('stag') > -1) {
                return loadStripe('pk_test_c0XXC0atZkWzQ74HPOz2WLID00UCOn6HFD');
            }
            else {
                return loadStripe('pk_live_IA4x8bd7SChdO7IoHjDYq8Vq004TJZhqPU');
            }
        },
        [process.env.NODE_ENV, document.location.host],
    )

    return !props.item ? null : (<div className="sd-wrapper checkout-wrapper">
        <div className="nc-title">You are purchasing <span>{props.item.smsCredits}</span> credits for <span>${props.paysGst ? props.item.priceGST : props.item.price}</span></div>
        <Elements stripe={stripePromise}>
            <CheckoutForm id={props.item.id} />
        </Elements>
    </div>);
};


// WEBPACK FOOTER //
// ./src/pages/Store/StoreDetails.js